import React from "react";

import {
  ConfirmActionButtonV2 as ConfirmActionButton,
  PrimaryButton,
} from "@shared/buttons";

export function SubmitScheduledExportButtonWithConfirmationModal({
  buttonLabel = "SCHEDULE EXPORT",
  externalUsers,
  isDisabled = false,
  isLoading = false,
  className = "",
  onSubmit,
}: {
  buttonLabel?: string;
  externalUsers: string[];
  isDisabled?: boolean;
  isLoading?: boolean;
  className?: string;
  onSubmit(): void;
}) {
  const hasExternalUsers = externalUsers.length > 0;

  return (
    <ConfirmActionButton
      skipConfirmation={!hasExternalUsers}
      title={
        <div className="text-lg font-semibold">
          <i className="fa-regular fa-sharp fa-share-from-square mr-5" />
          Sharing with External Users
        </div>
      }
      description={
        <>
          <div className="mt-4">
            You&apos;re currently sharing your data with the following external
            users:
          </div>
          <div className="mt-2 flex flex-col gap-1">
            {externalUsers.map((userEmail) => (
              <ExternalUserChip key={userEmail} email={userEmail} />
            ))}
          </div>
          <div className="mt-4">Do you want to proceed?</div>
        </>
      }
      onConfirm={onSubmit}
      actionButton={
        <PrimaryButton
          isDisabled={isDisabled}
          loading={isLoading}
          className={className}
        >
          {buttonLabel}
        </PrimaryButton>
      }
    />
  );
}

const ExternalUserChip = ({ email }: { email: string }) => {
  return (
    <div
      className={`flex items-center justify-center gap-1 py-1 px-2 w-fit rounded-2xl
      bg-sun-2 bg-opacity-20 border border-sun
      text-sm text-text font-light`}
    >
      <i className="fa-regular fa-circle-exclamation text-sun+2" /> {email}
    </div>
  );
};
